export default "__VITE_ASSET__01caa3d8__"